import type { LeagueCreateInput, LeagueDetail, LeagueList, LeagueUpdateInput } from "@tnp/contracts";
import { apiRequest } from "../../../../shared/lib/api";

const auth = (token: string) => ({ Authorization: `Bearer ${token}` });
export function listLeagues(token?: string, offset = 0) {
  return apiRequest<LeagueList>(`${token ? "/api/organizer/leagues" : "/api/leagues"}?limit=24&offset=${offset}`, { headers: token ? auth(token) : {} });
}
export function getLeague(id: string, token?: string) {
  return apiRequest<LeagueDetail>(`${token ? "/api/organizer/leagues" : "/api/leagues"}/${encodeURIComponent(id)}`, { headers: token ? auth(token) : {} });
}
export function createLeague(token: string, body: LeagueCreateInput) {
  return apiRequest<LeagueDetail>("/api/organizer/leagues", { method: "POST", headers: auth(token), body: JSON.stringify(body) });
}
export function updateLeague(token: string, id: string, body: LeagueUpdateInput) {
  return apiRequest<LeagueDetail>(`/api/organizer/leagues/${encodeURIComponent(id)}`, { method: "PUT", headers: auth(token), body: JSON.stringify(body) });
}

export function deleteLeague(token: string, id: string, revision: number) {
  return apiRequest<{ ok: boolean }>(`/api/organizer/leagues/${encodeURIComponent(id)}`, { method: "DELETE", headers: auth(token), body: JSON.stringify({ revision }) });
}
